/* eslint-disable jsx-a11y/no-static-element-interactions */
import './terms-and-conditions.scss'

import classnames from 'classnames'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Header from '../../components/collections/Header'
import { CoverSpinning } from '../../components/elements'
import Modal from '../../components/modals/Modal'
import { useAppState } from '../../providers/store'
import services from '../../services'

export default function TermsAndConditions() {
    const navigate = useNavigate()
    const appState = useAppState()
    const [accepted, setAccepted] = useState(false)
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const { socialService } = services()

    const onClickCompleted = async () => {
        if (!accepted) return
        try {
            setLoading(true)
            const lineProfile = await window.liff.getProfile()
            await socialService.save({
                avatarUrl: lineProfile.pictureUrl!,
                cid: appState.cid,
                language: 'TH',
                osPlatform: window.liff.getOS()!.toUpperCase() as any,
                socialPlatform: 'Line',
                socialPlatformId: lineProfile.userId,
            })
            setLoading(false)
            navigate('/done')
        } catch (error) {
            console.log(error)
            setLoading(false)
            setShowModal(true)
        }
    }

    const onClickToggleAccepted = () => {
        setAccepted(!accepted)
    }

    const NoticeModal = () => {
        return (
            <Modal>
                <div className="notice-modal-content abcs-container">
                    <h4>ข้อมูลไม่ถูกต้อง</h4>
                    <p>ไม่สามารถทำรายการได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง</p>
                    <button
                        type="button"
                        className="abcs-button secondary"
                        onClick={() => {
                            setShowModal(false)
                        }}
                        style={{ color: 'white' }}
                    >
                        ปิด
                    </button>
                </div>
            </Modal>
        )
    }

    return (
        <>
            {loading && <CoverSpinning />}
            {showModal && <NoticeModal />}
            <div className="terms-and-conditions">
                <Header title="ยืนยันตัวตน" />
                <div className="abcs-container">
                    <div className="title">การให้ความยินยอมในการขอใช้บริการ</div>
                    <div className="divider-header" />
                    <div className="content">
                        <p>
                            ผู้ขอใช้บริการตกลงใช้บริการ Money Thunder ผ่าน LINE
                            ตามที่ได้รับอนุมัติจากธนาคาร และตามรายละเอียดการให้บริการที่ธนาคารกำหนด
                            โดยผู้ขอใช้บริการตกลงผูกพันตามข้อกำหนดและเงื่อนไข ดังต่อไปนี้
                        </p>
                        <p>1. คำนิยาม</p>
                        <p>
                            1.1 “ข้อมูลส่วนบุคคล” หมายความถึง ข้อมูลส่วนบุคคล ข้อมูลทางการเงิน
                            และ/หรือ ข้อมูลใดๆ ของผู้ขอใช้บริการที่ผู้ขอใช้บริการได้ให้ไว้แก่ธนาคาร
                            และ/หรือ ที่มีอยู่ในระบบฐานข้อมูลของธนาคาร และ/หรือ
                            ที่ธนาคารเก็บรวบรวมมาจากบุคคลอื่นใด
                        </p>
                        <p>
                            1.2 “เครื่องมือเพื่อการทำรายการ” หมายความถึง โทรศัพท์มือถือ และ/หรือ
                            แท็บเล็ต และ/หรือ เครื่องมืออื่นใดตามที่ธนาคารกำหนด
                            เพื่อใช้ในการทำรายการ
                        </p>
                        <p>
                            1.3 “ธนาคาร” หมายความถึง ธนาคารไทยพาณิชย์ จำกัด (มหาชน)
                            และให้หมายความรวมถึงบุคคลที่ธนาคารมอบหมายด้วย
                        </p>
                        <p>
                            1.4 “บัญชี PromptPay” หมายความถึง บัญชีเงินฝากของผู้ขอใช้บริการ และ/หรือ
                            บัญชีเงินฝากของบุคคลอื่น ที่ได้ผูกเป็นบัญชีพร้อมเพย์กับธนาคาร
                            หรือสถาบันการเงินอื่นใดแล้ว
                        </p>
                        <p>
                            1.5 “รหัสประจำตัว” หมายความถึง Login Name หรือ Username, รหัสผ่าน
                            (Password), PIN – Person Identification Number, ลายนิ้วมือ, รหัส OTP –
                            One Time Password รวมถึงรหัสอื่นใดที่เกี่ยวข้องกับการเข้าใช้ Application
                            ไม่ว่าจะเรียกด้วยชื่อใดๆ และไม่ว่าจะเป็นรหัสที่ธนาคารเป็นผู้กำหนดให้
                            หรือเป็นรหัสที่ผู้ขอใช้บริการเป็นผู้กำหนดเองก็ตาม
                        </p>
                        <p>
                            1.6 “รายการ” หมายความถึง คำสั่ง หรือธุรกรรมต่าง ๆ ที่กระทำผ่าน
                            Application เช่น การสร้าง QR Code การบันทึกการรับชำระเงินด้วยเงินสดหรือ
                            PromptPay และ/หรือ การลงข้อความ หรือรูปภาพ
                            เกี่ยวกับการทำรายการส่งเสริมการขายของผู้ขอใช้บริการ เป็นต้น
                        </p>
                        <p>
                            1.7 “เหตุสุดวิสัย” หมายความถึง เหตุใดๆ อันอยู่นอกเหนือการควบคุมของธนาคาร
                            ซึ่งเป็นอุปสรรคต่อการให้บริการตามข้อกำหนดและเงื่อนไขนี้
                            รวมถึงเป็นเหตุให้เกิดข้อขัดข้อง หรือข้อมูลผิดพลาด เช่น
                            ระบบคอมพิวเตอร์ของธนาคารหรือระบบสื่อสารขัดข้องเพราะกระแสไฟฟ้าขัดข้อง
                            หรือปัญหาด้านพลังงาน การกระทำของบุคคลภายนอก ไวรัสคอมพิวเตอร์
                            หรือข้อมูลที่เป็นอันตรายต่างๆ (Harmful Data) ซึ่งเหตุดังกล่าวไม่ได้
                            มีสาเหตุมาจากการที่ธนาคารไม่ดูแลรักษาระบบคอมพิวเตอร์อย่างเพียงพอตามมาตรฐาน
                        </p>
                        <p>
                            1.8 “Application” หมายความถึง บริการ SCB Easy Cashier
                            ตามข้อกำหนดและเงื่อนไขการใช้บริการนี้
                        </p>
                    </div>
                    <div className="accept-consent">
                        <div className="checkbox-container">
                            <div className="checkbox" onClick={onClickToggleAccepted}>
                                {!accepted ? null : (
                                    <svg className="icon-checked" viewBox="0 0 24 24">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                )}
                            </div>
                            <input
                                className="checkbox-input"
                                type="checkbox"
                                name="accepted"
                                onChange={onClickToggleAccepted}
                                checked={accepted}
                            />
                            <label className="label-checkbox">ยอมรับเงื่อนไข</label>
                        </div>
                        <button
                            type="button"
                            className={classnames('abcs-button primary', !accepted && 'disabled')}
                            onClick={onClickCompleted}
                        >
                            ไปต่อ
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
